import { translate } from "app/filters/i18nFilter";
import { noop } from "lodash";
import type {
    ButtonComponentProps,
} from "app/pages/sales-intelligence/common-components/MultiSelector/Buttons/SubmitButton";
import SubmitButton from "app/pages/sales-intelligence/common-components/MultiSelector/Buttons/SubmitButton";
import { StyledPanelIconButton } from "./styles";

type Props = {
    isDisabled: boolean;
    isLoading: boolean;
    onClick?(): void;
    text: string;
    dataAutomation?: string;
    tooltipContent: string;
};

const PanelSubmitIconButton = (props: Props) => {
    const { isDisabled = false, isLoading = false, text, dataAutomation = "", tooltipContent, onClick = noop } = props;
    return (
        <SubmitButton
            isDisabled={isDisabled}
            isLoading={isLoading}
            onClick={onClick}
            ButtonComponent={(props: ButtonComponentProps) => (
                <StyledPanelIconButton
                    {...props}
                    showLoaderIcon={false}
                    iconName="arrow"
                    iconSize="10px"
                    placement="right"
                />
            )}
            dataAutomation={dataAutomation}
            label={isLoading ? translate("si.common.button.adding") : text}
            tooltipContent={tooltipContent}
        />
    );
}

export default PanelSubmitIconButton;
